<template>
  <div class="content">
    <CustomTable ref="CustomTable" v-loading="loading" @init="init" @handelBtnClick="handelBtnClick"
      @handelTableChange="handelTableChange" @handelTableClick="handelTableClick" :filterData="filterData"
      :headerData="headerData" :btnsData="btnsData" :data="data" :pagination="pagination">
      <el-table-column label="操作" fixed="right" align="center" width="180px">
        <template slot-scope="scope">
          <el-link @click="handelTableClick(scope.row, 'comment')">评论</el-link>
          <el-link @click="handelTableClick(scope.row, 'view')">查看</el-link>
          <el-link @click="handelTableClick(scope.row, 'edit')">编辑</el-link>
          <el-popconfirm title="确定删除吗？" @confirm="handelTableClick(scope.row, 'delete')">
            <el-link slot="reference">删除</el-link>
          </el-popconfirm>
        </template>
      </el-table-column>
    </CustomTable>
    <el-dialog :title="createdType == 'add' ? '新增' : '修改'" :visible.sync="dialogVisible" width="1000px"
      :close-on-click-modal="false">
      <CustomForm ref="CustomForm" :data="addFormData" @change="handelForm" />
    </el-dialog>
    <CustomArticle ref="CustomArticle" />
    <el-drawer title="评论列表" :visible.sync="drawer" direction="rtl" size="60%">
      <div style="padding: 0 20px;">
        <el-input v-model="keyword" placeholder="请输入关键字" size="small" style="width: 500px;margin-right: 20px;"
          clearable></el-input>
        <el-button type="primary" size="small" @click="confirmComment">确 认</el-button>
        <!-- table -->
        <el-table :data="commentList" border style="margin-top: 20px;">
          <el-table-column label="评论人" prop="memberName" align="center" width="180px"></el-table-column>
          <el-table-column label="内容" prop="comment"></el-table-column>
          <el-table-column label="评论时间" prop="createTime" align="center" width="180px"></el-table-column>
          <el-table-column label="操作" width="80px" align="center">
            <template slot-scope="scope">
              <el-popconfirm title="确定删除吗？" @confirm="handelTableClick(scope.row, 'deleteComment')">
                <el-link slot="reference">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <!-- pagination -->
        <el-pagination @current-change="handelPageChange" :current-page="commentPagination.current"
          :page-size="commentPagination.pageSize" layout="total, prev, pager, next, jumper"
          :total="commentPagination.total">
        </el-pagination>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import CustomArticle from "@/components/custom/CustomArticle";
import CustomForm from "@/components/custom/CustomForm";
import CustomTable from "@/components/custom/CustomTable";
import moment from "moment"
export default {
  components: { CustomArticle, CustomForm, CustomTable },
  data() {
    return {
      filterData: [
        { label: "栏目", prop: "catId", type: "cascader", opt: [], value: "", span: 12 },
        { label: "标题", prop: "title", type: "input", value: "", span: 12 },
        { label: "系统发布", prop: "accountId", type: "select", filterable: true, url: this.$api.Management.accountList, key: "userName", opt: [], value: "", span: 6 },
        { label: "单位发布", prop: "unitId", type: "select", filterable: true, url: this.$api.Members.institutionalList, key: "name", opt: [], value: "", span: 6 },
        { label: "个人发布", prop: "memberId", type: "select", filterable: true, url: this.$api.Members.personalList, key: "userName", opt: [], value: "", span: 6 },
        {
          label: "审核状态",
          prop: "auditingStatus",
          type: "select",
          value: "",
          span: 6,
          opt: [
            { label: "待审核", value: "PADDING" },
            { label: "通过", value: "PASS" },
            { label: "不通过", value: "FAIL" },
          ],
        },
        { label: "标签", prop: "tag", type: "input", value: "", span: 6, },
        {
          label: "状态",
          prop: "status",
          type: "select",
          value: "",
          span: 6,
          opt: [
            { label: "启用", value: true },
            { label: "禁用", value: false },
          ],
        },
        {
          label: "评论功能",
          prop: "status",
          type: "select",
          value: "",
          span: 6,
          opt: [
            { label: "是", value: true },
            { label: "否", value: false },
          ],
        },
        {
          label: "置顶",
          prop: "topShow",
          type: "select",
          value: "",
          span: 6,
          opt: [
            { label: "是", value: true },
            { label: "否", value: false },
          ],
        },
      ],
      headerData: [
        { label: "栏目名称", prop: "catName", align: "left" },
        { label: "标题", prop: "title", align: "left" },
        { label: "标签", prop: "tags", type: "tag" },
        { label: "浏览量", prop: "readCount" },
        { label: "点赞数", prop: "likeCount" },
        { label: "数据来源", prop: "type" },
        { label: "允许评论", prop: "canComment" },
        { label: "置顶", prop: "topShow", type: "switch" },
        {
          label: "审核状态",
          prop: "auditingStatus",
          type: "audit",
          opt: [
            { label: "通过", value: "PASS" },
            { label: "不通过", value: "FAIL", check: true },
          ],
        },
        { label: "状态", prop: "status", type: "switch" },
        { label: "创建时间", prop: "createTime" },
      ],
      btnsData: [{ label: "新增", value: "add", type: "primary" }],
      data: [],
      addFormData: [
        { label: "栏目", prop: "catId", type: "cascader", opt: [], required: true, value: "", span: 12 },
        { label: "标题", prop: "title", type: "input", value: "", required: true, span: 24 },
        { label: "简介", prop: "descString", type: "textarea", value: "", required: true, span: 24 },
        // {
        //   label: "置顶",
        //   prop: "topShow",
        //   type: "select",
        //   value: false,
        //   opt: [
        //     { label: "是", value: true },
        //     { label: "否", value: false },
        //   ],
        // },
        {
          label: "开启评论",
          prop: "canComment",
          type: "select",
          value: true,
          opt: [
            { label: "是", value: true },
            { label: "否", value: false },
          ],
        },
        { label: "标签", prop: "tags", type: "tag", value: [], span: 24 },
        {
          label: "图片",
          prop: "imgs",
          type: "upload",
          value: [],
          span: 24,
          required: false,
          limit: 10
        },
        {
          label: "正文",
          prop: "content",
          type: "editor",
          value: "",
          span: 24,
          required: true,
          height: "500px"
        },
      ],
      loading: false,
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      selectData: {},
      dialogVisible: false,
      createdType: "",
      catsData: [],
      drawer: false,
      commentList: [],
      keyword: "",
      commentPagination: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    };
  },
  created() {
    this.$https.get(this.$api.ContentManagement.mgrcatList).then((res) => {
      this.catsData = changeTreeData(res, "tree");
      this.filterData = this.filterData.map(el => {
        let obj = el
        if (el.prop == 'catId') {
          el.opt = this.catsData
        }
        return obj
      })
    });
    function changeTreeData(data, pid) {
      return data
        .filter((el) => el.pid == pid)
        .map((el) => {
          const children = changeTreeData(data, el.id)
          return {
            label: el.name,
            value: el.id,
            children: children.length ? children : null,
          };
        });
    }
  },
  methods: {
    confirmComment() {
      this.commentPagination = {
        pageSize: 10,
        current: 1,
        total: 0,
      };
      this.initCommentList()
    },
    handelPageChange(page) {
      this.commentPagination.current = page
      this.initCommentList()
    },
    // 获取栏目在树中的路径，供级联回显
    getCatPath(tree, id, path = []) {
      for (const node of tree) {
        const currentPath = path.concat(node.value)
        if (node.value === id) {
          return currentPath
        }
        if (node.children) {
          const found = this.getCatPath(node.children, id, currentPath)
          if (found) return found
        }
      }
      return null
    },
    initCommentList() {
      this.$https
        .get(this.$api.ContentManagement.articleCommentList, { id: this.selectData.id, keyword: this.keyword, current: this.commentPagination.current - 1 })
        .then((res) => {
          this.drawer = true
          this.commentPagination = {
            pageSize: res.pageSize,
            current: res.currentPage + 1,
            total: res.count,
          };
          this.commentList = res.data ? res.data.map(el => {
            return Object.assign(el, {
              memberName: el.memberName + (el.unitName ? ' (' + el.unitName + ')' : ''),
              createTime: moment(el.createTime).format("yyyy-MM-DD HH:mm:ss")
            })
          }) : []
        });
    },
    handelTableChange(data) {
      let url = ""
      let params = {}
      let ajaxType = "get"
      switch (data.prop) {
        case "status":
          url = this.$api.ContentManagement.articleUpdateStatus
          params = {
            status: data.data.status ? "active" : "inactive"
          }
          break;
        case "auditingStatus":
          url = this.$api.ContentManagement.articleAuditing
          params = data.value
          ajaxType = "post"
          break;
        case "topShow":
          url = this.$api.ContentManagement.articleTopshow
          params = {
            topShow: data.data.topShow
          }
          break;
      }
      this.$https[ajaxType](url + data.data.id, params)
        .then((res) => {
          this.$message.success("修改成功")
          this.$refs.CustomTable.search()
        });
    },
    handelForm(data) {
      if (!Object.keys(data).length) {
        this.dialogVisible = false;
        return;
      }
      let params = Object.assign(data, {
        catId: data.catId[data.catId.length - 1],
      });
      params.status = params.status ? "active" : "inactive";
      const url = this.createdType == "add" ? this.$api.ContentManagement.articleAdd : this.$api.ContentManagement.articleUpdate + this.selectData.id
      this.$https
        .post(url, params)
        .then((res) => {
          this.$message.success(this.createdType == "add" ? "新增正常" : "修改成功")
          this.dialogVisible = false;
          this.$refs.CustomTable.search()
        });
    },
    handelTableClick(data, type) {
      this.createdType = type;
      switch (type) {
        case "deleteComment":
        this.$https
            .get(this.$api.ContentManagement.articleDeleteComment + data.id)
            .then((res) => {
              this.$message.success("删除成功")
              this.initCommentList()
            });
        break;
        case "comment":
          this.selectData = data
          this.keyword = ""
          this.confirmComment()
          break;
        case "view":
          this.$refs.CustomArticle.showDialog(data.id)
          break;
        case "delete":
          this.$https
            .get(this.$api.ContentManagement.articleDelete + data.id)
            .then((res) => {
              this.$message.success("删除成功")
              this.$refs.CustomTable.search()
            });
          break;
        case "edit":
          this.selectData = data
          this.$https.get(this.$api.ContentManagement.articleDetail + data.id).then(res => {
            this.addFormData = this.addFormData.map((el) => {
              let value = res[el.prop]
              if (el.prop == "status") {
                value = res[el.prop] == "active" ? true : false
              }
              if (el.prop == 'catId') {
                value = this.getCatPath(this.catsData, res[el.prop]) || [res[el.prop]]
                el.opt = this.catsData
              }
              return Object.assign(el, { value: value });
            });
            this.dialogVisible = true;
          })
          break;
      }
    },
    handelBtnClick(type) {
      this.createdType = type;
      switch (type) {
        case "add":
          this.addFormData = [
            { label: "栏目", prop: "catId", type: "cascader", opt: this.catsData, required: true, value: "", span: 12 },
            { label: "标题", prop: "title", type: "input", value: "", required: true, span: 24 },
            { label: "简介", prop: "descString", type: "textarea", value: "", required: true, span: 24 },
            // {
            //   label: "置顶",
            //   prop: "topShow",
            //   type: "select",
            //   value: false,
            //   opt: [
            //     { label: "是", value: true },
            //     { label: "否", value: false },
            //   ],
            // },
            {
              label: "开启评论",
              prop: "canComment",
              type: "select",
              value: true,
              opt: [
                { label: "是", value: true },
                { label: "否", value: false },
              ],
            },
            {
              label: "状态",
              prop: "status",
              type: "select",
              value: true,
              opt: [
                { label: "启用", value: true },
                { label: "禁用", value: false },
              ],
            },
            { label: "标签", prop: "tags", type: "tag", value: [], span: 24 },
            {
              label: "图片",
              prop: "imgs",
              type: "upload",
              value: [],
              span: 24,
              required: false,
              limit: 10
            },
            {
              label: "正文",
              prop: "content",
              type: "editor",
              value: "",
              span: 24,
              required: true,
              height: "500px"
            },
          ];
          this.dialogVisible = true;
          break;
      }
    },
    init(data) {
      this.loading = true;
      let params = data || {};
      if (Object.keys(params).includes("status")) {
        params.status = params.status ? "active" : "inactive";
      }
      if (params.catId) {
        params.catId = params.catId[params.catId.length - 1]
      }
      params.current -= 1
      this.$https
        .get(this.$api.ContentManagement.articleList, params)
        .then((res) => {
          this.pagination = {
            pageSize: res.pageSize,
            current: res.currentPage + 1,
            total: res.count,
          };
          this.data = res.data
            ? res.data.map((el) => {
              return Object.assign(el, {
                status: el.status == "active" ? true : false,
                canComment: el.canComment ? "是" : "否",
                type: el.type == "ACCOUNT" ? "系统发布" : (el.type == "UNIT" ? "单位发布" : "个人发布"),
                auditingStatus: el.auditingStatus == "PADDING" ? "" : el.auditingStatus,
                createTime: moment(el.createTime).format("yyyy-MM-DD HH:mm:ss")
              });
            })
            : [];
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  position: relative;
  width: 100%;
  overflow: hidden;
}

/deep/.el-dialog__body {
  padding: 0;
}

.el-pagination {
  text-align: center;
  padding: 10px 0;
}
</style>